<h1 class="page-title">Contact Us</h1>

<mat-card class="contact-card" appearance="outlined">
  <mat-card-header>
    <mat-card-title class="card-title">Provider Contacts</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <p class="description">Please select the county of residence below to view local transportation provider contact information.</p>

    <div class="county-select">
      <label class="field-label" id="county-residence-lbl">County of Residence</label>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label id="county-lbl">Select a county</mat-label>
        <input
          id="county-input"
          type="text"
          [(ngModel)]="selectedCounty"
          (ngModelChange)="onSearchChange($event)"
          matInput
          [matAutocomplete]="auto"
          placeholder="Select a county"
          aria-labelledby="county-residence-lbl county-lbl" />

        @if (selectedCounty) {
          <button mat-icon-button matSuffix class="clear-btn" aria-label="Clear status selection" (click)="onClearCounty(); $event.stopPropagation()">
            <mat-icon>close</mat-icon>
          </button>
        }

        <mat-autocomplete #auto="matAutocomplete" [displayWith]="countyDisplayValueFn" (optionSelected)="onCountySelected($event.option.value)">
          @for (county of filteredCounties; track county.countyId) {
            <mat-option [value]="county">
              {{ county.countyName }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    @if (organizations) {
      <div class="organizations w-100">
        <div class="w-100 title d-flex align-items-center">
          <h2>Transportation Provider</h2>
        </div>
        @for (org of organizations; track $index) {
          <div class="org d-flex flex-column mt-10">
            <span class="org-name">{{ org.organizationName }}</span>
            <span class="address">{{ org.address }}</span>
            @if (org.phoneNumber) {
              <span>Phone: {{ org.phoneNumber | phoneFormat }}</span>
            }
            @if (org.faxNumber) {
              <span>Fax: {{ org.faxNumber | phoneFormat }}</span>
            }
            <span>
              <a [href]="'mailto:' + org.email">{{ org.email }}</a>
            </span>
          </div>
        }
      </div>
    }
  </mat-card-content>
</mat-card>
